import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/special/Header';
import ExoCategories from '../../components/exo/ExoCategories';
import ExoPresets from '../../components/exo/ExoPresets';

const Presets = () => {
  const { t } = useTranslation();
  const { type } = useParams();

  console.log(`${type}presets`);

  return (
    <>
      <Header title={t('Presets')} />
      <ExoPresets path={`${type}-presets`} />
    </>
  );
};

export default Presets;
